import LMSAdminEpicClient from 'bundles/epic/clients/LMSAdmin';

export function canShowDistinctAvailabilityReviewDates(partnerIds: number[]) {
  const designatedPartnersForNewFeature = LMSAdminEpicClient.get('distinctAvailabilitySettingsPartners').map(
    (partnerId: number) => partnerId.toString()
  );
  return partnerIds?.some((id) => designatedPartnersForNewFeature.includes(id));
}
